import { render, staticRenderFns } from "./EditUserDetailsForm.vue?vue&type=template&id=f611db48&"
import script from "./EditUserDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./EditUserDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserDetailsForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports